import { render } from "./ErrorPage.vue?vue&type=template&id=6b311fc9&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"

import "../assets/scss/error_page.scss?vue&type=style&index=0&id=6b311fc9&scoped=true&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b311fc9"]])

export default __exports__